import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router';

import styled from '@emotion/styled';

import DashboardHeader from './header/DashboardHeader';
import MobileNav from './sideNav/MobileNav';
import Nav from './sideNav/Nav';

const DashboardLayoutOutlet = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <Container ref={containerRef}>
      <Nav />
      <MobileNav />
      <Section>
        <DashboardHeader />
        <MainContent>
          <Outlet />
        </MainContent>
      </Section>
    </Container>
  );
};

export default DashboardLayoutOutlet;

const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background-color: white;
`;

const Section = styled.section`
  /* border: 1px solid red; */
  width: 100%;
  height: fit-content;
`;

const MainContent = styled.main`
  height: 100%;
  padding-bottom: 200px;
  width: 100%;
  /* border: 1px solid blue; */
`;
